import React, {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_metronic/partials'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import ActivatedPageRoute from './ActivatedPageRoute'
import {PAGE_PERMISSION} from '../modules/roles/constant/role-default'
import {Page, ReportDetail} from '../modules/roles/models/role-model'
import ActivePageBasedRedirect from './ActivePageBasedRedirect'

type Props = {
  activePages: Page[]
}

const PrivateRoutes: React.FC<Props> = ({activePages = []}) => {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))

  const FeaturePage = lazy<React.FC>(() => import('../modules/features/FeaturePage'))
  const ChartsPage = lazy<React.FC>(() => import('../modules/charts/ChartPage'))
  const UsersPage = lazy<React.FC>(() => import('../modules/users/UserPage'))
  const RolesPage = lazy<React.FC>(() => import('../modules/roles/RolePage'))
  const SettingsPage = lazy<React.FC>(() => import('../modules/settings/SettingsPage'))
  const AuditsPage = lazy<React.FC>(() => import('../modules/audits/AuditPage'))

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        {/*<Route path='/dashboard' component={DashboardWrapper} /> */}
        {/*<Route path='/user' render={() => <UserPage />} />*/}
        {/*<Route path='/role' render={() => <RolePage />} />*/}
        {/*<Route path='/feature' render={() => <FeaturePage />} />*/}

        <ActivatedPageRoute
          path='/dashboard'
          component={DashboardWrapper}
          permission={PAGE_PERMISSION.Dashboard}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path='/charts'
          component={ChartsPage}
          permission={PAGE_PERMISSION.Charts}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path='/user'
          component={UsersPage}
          permission={PAGE_PERMISSION.Users}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path='/role'
          component={RolesPage}
          permission={PAGE_PERMISSION.Roles}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path='/feature'
          component={FeaturePage}
          permission={PAGE_PERMISSION.Features}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path='/settings'
          component={SettingsPage}
          permission={PAGE_PERMISSION.Features}
          activePages={activePages}
        />

        <ActivatedPageRoute
          path='/audit'
          component={AuditsPage}
          permission={PAGE_PERMISSION.Audit}
          activePages={activePages}
        />

        <ActivePageBasedRedirect></ActivePageBasedRedirect>
        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  )
}

export {PrivateRoutes}
